/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Space, Popover, Tag, Drawer, Row, Col, Descriptions, Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CheckOutlined, DownOutlined } from '@ant-design/icons';
import Joyride, { STATUS, EVENTS, ACTIONS } from 'react-joyride';
import { updatePlanModal, updateNavigationTourGuide } from 'store/user';
import EbzTable from 'components/EbzTable';
import EbzButton from 'components/EbzButton';
import EbzFilterGroup from 'components/EbzFilterGroup';
import Alert from 'components/Alert';
import reportsAPI from 'services/reports';
import merchantAPI from 'services/merchants';
import { CloseIcon, CopyIcon } from 'utils/icons';
import currencyFormat from 'utils/currencyFormat';
import { INVOICE_STATUS, PAYOUT_REPORT_STATUS } from 'constants/status';
import dayjs from 'dayjs';
import PayoutReportBlur from 'assets/images/payoutreport_table.webp';
import joyrideCustomTooltip from 'components/JoyrideComponent/JoyrideTooltip';
import { TOUR_INVOICE_CONTENT } from './const';

const filtersArr = [];

const searchArr = [
  {
    value: 'partner_invoice_no',
    label: 'Invoice Number'
  }
];

function InvoicesListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [data, setData] = useState({});
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  const [tourGuideRun, setTourGuideRun] = useState(false);
  const [tourGuideSteps, setTourGuideSteps] = useState([]);
  const [tourStepIndex, setTourStepIndex] = useState(1);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0
    }
  });
  const [filtersObj, setFiltersObj] = useState({});

  // const planType = useSelector((state) => state.user.plan.plan_type);
  const isInvoicesAllowed = useSelector((state) => state.user.planPermissions.can_view_invoices);
  const planModal = useSelector((state) => state.user.planModal);
  const tourGuide = useSelector((state) => state.user.navigationTourGuidetails);

  const dispatch = useDispatch();
  const togglePlanModal = () => {
    dispatch(updatePlanModal(!planModal));
  };

  const handleViewMore = (e) => {
    setViewMoreModal(e);
    setCurrentView(null);
  };

  // functions for api
  const fetchInvoiceList = async (pagination, filters) => {
    setLoading(true);

    const response = await reportsAPI.invoiceList({
      current_page: pagination.current,
      total_counts: pagination.total,
      ...filters
    });

    if (!response.success) {
      console.log('something went wrong');
      // Alert('something went wrong', 'Please contact support team for this', 'error');
      setHasData(false);
    }

    setData(response?.data ?? []);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...pagination,
        total: response?.data.total_counts
      }
    });
  };
  //

  // functions
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter
    });

    fetchInvoiceList(pagination, filtersObj);
  };

  const applyFiltersCallbackfunc = (a) => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    const [searchParams, checkboxGroup] = a;
    const filters = {
      ...searchParams,
      ...checkboxGroup
    };
    setFiltersObj(filters);
    fetchInvoiceList(updatePagination, filters);
  };

  const clearFiltersCallBackfun = () => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;
    setFiltersObj({});
    fetchInvoiceList(updatePagination);
  };

  const handleDownloadReport = async (Uniqueid, Uniquekey) => {
    const response = await reportsAPI.downloadReport({
      unique_id: Uniqueid,
      unique_key: Uniquekey
    });

    if (response.success) {
      window.open(response.data.url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
  };
  // effects
  useEffect(() => {
    if (isInvoicesAllowed) {
      fetchInvoiceList(tableParams.pagination);
    } else {
      navigate('/referrals');
    }
  }, [isInvoicesAllowed]);
  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      setHasData(true);
    }
  }, [data]);
  //

  const handleViewDetails = (e) => {
    handleViewMore(true);

    const t = PAYOUT_REPORT_STATUS[e.status] ? (
      <Tag
        color={PAYOUT_REPORT_STATUS[e.status].bgColor}
        style={{
          padding: '2px 13px',
          color: PAYOUT_REPORT_STATUS[e.status].color,
          fontSize: '12px'
        }}
      >
        {PAYOUT_REPORT_STATUS[e.status].label}
      </Tag>
    ) : (
      <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
        {e.status}
      </Tag>
    );
    const a = {
      format: {
        ...e,
        payout_start_date:
          e.document_created_at === null
            ? 'Invalid Date'
            : dayjs(e.document_created_at).format("DD MMM, 'YY"),
        payout_end_date:
          e.payout_end_date === null
            ? 'Invalid Date'
            : dayjs(e.payout_end_date).format("DD MMM, 'YY"),
        payout_generation_date:
          e.payout_generation_date === null
            ? 'Invalid Date'
            : dayjs(e.payout_generation_date).format("DD MMM, 'YY"),
        total_commission_amount: currencyFormat(e.total_commission_amount, true, true),
        dispute_amount: e?.dispute_amount && currencyFormat(e.dispute_amount, true, true),
        invoice_gst_amount:
          e?.invoice_gst_amount && currencyFormat(e.invoice_gst_amount, true, true),
        invoice_amount:
          e?.total_invoice_amount && currencyFormat(e.total_invoice_amount, true, true),
        status: t,

        ...(e.dispute_expired_at !== undefined && {
          expired: dayjs(e.dispute_expired_at).isBefore(dayjs()),
          dispute_expired_at:
            e.dispute_expired_at === null
              ? 'Invalid Date'
              : dayjs(e.dispute_expired_at).format("DD MMM, 'YY")
        })
      },
      unformat: { ...e }
    };

    setCurrentView(a);
  };

  const columns = [
    {
      title: <Space>Invoice Number</Space>,
      dataIndex: 'partner_invoice_no',
      key: 'partner_invoice_no',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: 'Invoice Upload Date',
      dataIndex: 'invoice_upload_date',
      key: 'invoice_upload_date',
      render: (e) => {
        return e === null ? 'Invalid Date' : dayjs(e).format("DD MMM, 'YY");
      }
    },
    {
      title: <Space>Gst Amount</Space>,
      dataIndex: 'total_gst_amount',
      key: 'total_gst_amount',
      render: (e) => {
        return (
          <Typography.Text style={{ wordSpacing: '5px' }}>
            {currencyFormat(e, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Space>Invoice Amount</Space>,
      dataIndex: 'total_invoice_amount',
      key: 'total_invoice_amount',
      render: (e) => {
        return (
          <Typography.Text style={{ wordSpacing: '9px' }}>
            {currencyFormat(e, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Space>Invoice Status</Space>,
      dataIndex: 'invoice_status',
      key: 'invoice_status',
      align: 'center',
      render: (status) => {
        const statusInfo = INVOICE_STATUS[status];
        return statusInfo?.render;
      }
    },
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (r) => {
        return (
          <EbzButton size="small" onClick={() => handleViewDetails(r)}>
            View Details
          </EbzButton>
        );
      }
    }
  ];

  const fetchAndUpdateNavigation = async (paramKey) => {
    const request = {
      update: paramKey
    };
    const response = await merchantAPI.fetchNavigationFlag(request);
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  const handleJoyrideCallback = (callbackProps) => {
    const { status, index, type, action, size } = callbackProps;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if ([ACTIONS.NEXT].includes(action)) {
        const nextIndex = index + 1;
        setTourStepIndex(nextIndex);
      } else {
        const prevIndex = index - 1;
        setTourStepIndex(prevIndex);
      }
      if (index === 1 && [ACTIONS.PREV].includes(action)) {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_invoice_guide');
      }
    }
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourGuideRun(false);
    }
    const lastStepIndex = size - index;
    if ([ACTIONS.CLOSE].includes(action) || [EVENTS.TOUR_END].includes(type)) {
      if (lastStepIndex > 1) {
        setTourStepIndex(size - 1);
      } else {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_invoice_guide');
      }
    }
  };

  useEffect(() => {
    if (
      tourGuide?.dashboard_guide?.tour_guide &&
      tourGuide?.dashboard_guide?.dashboard_modules?.disable_invoice_guide
    ) {
      setTourGuideRun(!tourGuideRun);
      setTourGuideSteps(TOUR_INVOICE_CONTENT);
    }
  }, [tourGuide]);

  return (
    <div
      style={{
        padding: '10px 24px'
      }}
    >
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={tourGuideRun}
        steps={tourGuideSteps}
        scrollOffset={64}
        showSkipButton
        styles={{
          options: {
            primaryColor: 'var(--color-fill-alter)',
            zIndex: 100
          }
        }}
        tooltipComponent={joyrideCustomTooltip}
        stepIndex={tourStepIndex}
      />
      <Space
        direction="horizontal"
        style={{ width: '100%', marginBottom: '10px', justifyContent: 'space-between' }}
      >
        <Space>
          {isInvoicesAllowed ? (
            <Popover
              placement="bottomLeft"
              content={
                <EbzFilterGroup
                  searchParams={searchArr}
                  filters={filtersArr}
                  apply={applyFiltersCallbackfunc}
                  clear={clearFiltersCallBackfun}
                />
              }
              trigger="click"
              overlayStyle={{
                width: '400px'
              }}
              overlayClassName="ebz-filters-popover"
            >
              <EbzButton size="large" className="ebz-filters-btn">
                Search & Filter <DownOutlined />
              </EbzButton>
            </Popover>
          ) : (
            <Button type="primary" size="large" disabled>
              Search & Filter <DownOutlined />
            </Button>
          )}
        </Space>
      </Space>
      {isInvoicesAllowed ? (
        <EbzTable
          columns={columns}
          // eslint-disable-next-line no-underscore-dangle
          rowKey={(r) => `report_${r._id}`}
          dataSource={hasData ? data.data : []}
          loading={loading}
          pagination={tableParams.pagination}
          onChange={handleTableChange}
          size="middle"
        />
      ) : (
        <div
          style={{
            position: 'relative'
          }}
        >
          <img src={PayoutReportBlur} alt="CUstom Report Table" style={{ maxWidth: '100%' }} />
          <div
            style={{
              position: 'absolute',
              textAlign: 'center',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            <Typography.Title level={4}>
              Explore trends, search through new Invoices from the dashboard on the Premium Plan.
            </Typography.Title>
            <Button type="primary" onClick={togglePlanModal}>
              View Plans
            </Button>
          </div>
        </div>
      )}
      <Drawer
        title={
          <CloseIcon
            style={{
              fontSize: '30px',
              color: 'var(--color-primary)',
              position: 'absolute',
              top: '30px',
              left: '-16px',
              cursor: 'pointer'
            }}
            onClick={() => handleViewMore(false)}
          />
        }
        placement="right"
        width={550}
        closable={false}
        open={viewMoreModal}
        rootClassName="payout-drawer"
      >
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Typography.Text style={{ fontSize: '22px', fontWeight: '500' }}>
              Invoice Report Details
            </Typography.Text>
          </Col>
          <Col span={24}>
            <Space
              direction="horizontal"
              style={{ width: '100%', justifyContent: 'space-between' }}
            >
              <Typography.Text
                copyable={{
                  icon: [
                    <CopyIcon style={{ color: 'var(--color-primary)' }} />,
                    <CheckOutlined style={{ color: 'var(--color-primary)' }} />
                  ]
                }}
              >
                {currentView?.format?._id}
              </Typography.Text>
            </Space>
          </Col>
          <Col span={24}>
            <Descriptions column={1} bordered labelStyle={{ backgroundColor: '#FFFFFF' }}>
              <Descriptions.Item label="Report Name">{currentView?.format?._id}</Descriptions.Item>
              <Descriptions.Item label="Easebuzz GST">27AAVCS2699M1Z5</Descriptions.Item>
              <Descriptions.Item label="Invoice Number">
                <Typography.Text
                  copyable={{
                    icon: [
                      <CopyIcon style={{ color: 'var(--color-primary)' }} />,
                      <CheckOutlined style={{ color: 'var(--color-primary)' }} />
                    ]
                  }}
                >
                  {currentView?.format?.partner_invoice_no}
                </Typography.Text>
              </Descriptions.Item>
              <Descriptions.Item label="Generation Date">
                {currentView?.format?.invoice_upload_date}
              </Descriptions.Item>
              <Descriptions.Item label="Commission Amount">
                {currentView?.format?.total_commission_amount}
              </Descriptions.Item>
              {currentView?.format?.invoice_gst_amount !== undefined && (
                <Descriptions.Item label="GST Amount">
                  {currentView?.format?.invoice_gst_amount}
                </Descriptions.Item>
              )}
              {currentView?.format?.invoice_amount !== undefined && (
                <Descriptions.Item label="Invoice Amount">
                  {currentView?.format?.invoice_amount}
                </Descriptions.Item>
              )}
              {currentView?.unformat?.payout_ids !== undefined && (
                <Descriptions.Item label="Payout IDs">
                  {currentView?.unformat?.payout_ids.map((id) => {
                    return <Tag color="purple">{id}</Tag>;
                  })}
                </Descriptions.Item>
              )}
              {currentView?.format?.payout_utr !== undefined && (
                <Descriptions.Item label="UTR">{currentView?.format?.payout_utr}</Descriptions.Item>
              )}
              <Descriptions.Item label="Downloads">
                {currentView?.unformat?.transaction_report_url !== null && (
                  <EbzButton
                    size="middle"
                    onClick={() => {
                      handleDownloadReport(
                        currentView?.format?._id,
                        currentView?.unformat?.partner_invoice_url
                      );
                    }}
                  >
                    <span style={{ textDecoration: 'underline' }}>Uploaded Invoice</span>
                  </EbzButton>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="Invoice Status">
                <Tag color={INVOICE_STATUS[currentView?.format?.invoice_status]?.color}>
                  {INVOICE_STATUS[currentView?.format?.invoice_status]?.tag}
                </Tag>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Drawer>
    </div>
  );
}

export default InvoicesListPage;
